<script>
import moment from 'moment';
import Layout from "../../layouts/main";
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/pt-br';
import appConfig from "@/app.config";

import PendencyService from '@/services/pendency'

moment.locale('pt-BR');

export default {
  page: {
    title: "Pendências Financeiras",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, DatePicker },
  data() {
    return {
      title: "Pendências Financeiras",
      loading: false,
      pendencies: [],
      searchParams: {
        customer: '',
        startDate: '',
        endDate: '',
        period: true,
      },
      searchEmptyField: false,
      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      totalPendencies: 0,

      fields: [
        { key: 'companyName', sortable: true, label: 'Empresa' },
        { key: 'customerName', sortable: true, label: 'Cliente' },
        { key: 'invoiceNumber', sortable: true, label: 'NF', formatter: (value, key, item) => {
          return `${item.invoiceNumber}/${item.installment}`
        } },
        { key: 'invoiceSeries', sortable: true, label: 'Série' },
        { key: 'installment', sortable: true, label: 'Parcela' },
        { key: 'value', sortable: true, label: 'Valor Vencido', class: 'nowrap-col', formatter: (value) => {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        },
        { key: 'dueDate', sortable: true, label: 'Data Vencimento', formatter: (value) => {
            return moment(value).format('DD/MM/YYYY');
          }
        },
        { key: 'sellerName', sortable: true, label: 'Vendedor' },
      ],
    };
  },
  mounted() {
    const now = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 365);

    this.searchParams.startDate = startDate;
    this.searchParams.endDate = now;

    this.search();
  },
  methods: {
    search() {
      this.searchEmptyField = false;
      this.load();
    },
    load(page = 1) {
      this.loading = true;

      if (!this.searchParams.startDate) {
        if (!this.searchParams.endDate) {
          this.searchParams.endDate = new Date();
        }
        
        const startDate = new Date(this.searchParams.endDate);
        startDate.setDate(startDate.getDate() - 7);
        this.searchParams.startDate = startDate;
      }

      if (!this.searchParams.endDate) {
        this.searchParams.endDate = new Date();
      }

      this.searchParams.page = page;

      PendencyService.getPendencies(this.searchParams)
        .then(res => {
          this.loading = false;

          this.pendencies = res.data.pendencies;
          this.count = res.data.count;
          this.currentCount = res.data.currentCount;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
          this.perPage = res.data.perPage;
          this.startIndex = res.data.startIndex;
          this.endIndex = res.data.endIndex;

          this.totalPendencies = res.data.totalPendencies;
        })
      .catch(() => {
        this.loading = false;
      })
    },
    onPageChange() {
      window.scrollTo(0,0);
      this.load(this.currentPage);
    },
    changeSearch() {
      if (this.searchParams.customer === '' && !this.searchEmptyField) {
        this.searchEmptyField = true;
        this.load();
      }
    },
    exportData() {
      this.loading = true;

      PendencyService.exportPendencies(this.searchParams).then(res => {
        this.loading = false;
        
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'PendenciasFinanceiras.xlsx');
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        this.loading = false;
      })
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="search" class="align-items-center">
              <div class="row">
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Cliente</label>
                    <input
                      type="text"
                      v-model="searchParams.customer"
                      class="form-control"
                      placeholder="Código ou razão social do cliente"
                      v-on:keyup="changeSearch"
                    />
                  </div>

                  <div class="custom-control custom-checkbox mb-2">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="searchParams.period" />
                    <label class="custom-control-label" for="customCheck1">Período</label>
                  </div>
                  
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group mb-3">
                        <!-- <label>Período de</label> -->
                        <date-picker
                          v-model="searchParams.startDate"
                          :first-day-of-week="1"
                          format="DD/MM/YYYY"
                          lang="pt-br"
                          :disabled="!searchParams.period"
                        ></date-picker>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="form-group mb-3">
                        <!-- <label>até</label> -->
                        <date-picker
                          v-model="searchParams.endDate"
                          :first-day-of-week="1"
                          format="DD/MM/YYYY"
                          lang="pt-br"
                          :disabled="!searchParams.period"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="button-search">
                <b-button type="submit" variant="primary" v-if="!loading">Filtrar</b-button>
                <b-button class="ml-2" variant="outline-primary" @click="exportData" v-if="!loading">Exportar</b-button>
                <a href="javascript:void(0);" class="text-primary" v-if="loading">
                  <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body"> 
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="pendencies"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <template slot="bottom-row">
                  <td colspan="4"></td>
                  <td class="text-left nowrap-col">
                    <strong>Valor Total:</strong>
                  </td>
                  <td class="text-left nowrap-col">
                    <h4 class="m-0">R$ {{totalPendencies | currency}}</h4>
                  </td>
                </template>
              </b-table>
            </div>
          </div>
        </div>

        <div class="row justify-content-md-between align-items-md-center mt-4">
          <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>
          <!-- end col-->
          <div class="col-xl-5">
            <div class="text-md-right float-xl-right mt-2 pagination-rounded">
              <b-pagination
                v-model="currentPage" 
                :total-rows="count"
                :per-page="perPage"
                @input="onPageChange"
              ></b-pagination>
            </div>
          </div>
          <!-- end col-->
        </div>
      </div>
    </div>
  </Layout>
</template>


<style lang="scss">
  .button-search {
    display: flex;
    align-items: center;
  }

  .mx-input:disabled {
    background-color: #e8e8e8 !important;
  }

  .nowrap-col {
    white-space: nowrap;
  }
</style>